module.exports = __webpack_public_path__ + "img/publication-rot.a0d516e5.svg";